export const GYPH_MESURING_DUMP: any[] = [];

export interface Options {
  family: string;
  size: number;
}

export interface MeasurementResult {
  capHeight: number;
  height: number;
  depth: number;
}

export class GlyphMeasurer {
  private static _instance?: GlyphMeasurer;
  // private _svg: SVGSVGElement;
  private _cache: { [key: string]: MeasurementResult } = {};
  private _canvas: HTMLCanvasElement;
  private _context: CanvasRenderingContext2D;

  private constructor() {
    this._canvas = document.createElement('canvas');
    this._canvas.setAttribute('class', 'glyph-measurer');
    document.body.appendChild(this._canvas);
    this._context = this._canvas.getContext('2d', {
      willReadFrequently: true,
    }) as CanvasRenderingContext2D;
    // initializing the canvas
    this.measureChar('a', { family: '', size: 50 });
  }

  public static get instance(): GlyphMeasurer {
    if (!GlyphMeasurer._instance) {
      GlyphMeasurer._instance = new GlyphMeasurer();
    }
    return GlyphMeasurer._instance;
  }

  public static destroy() {
    document.querySelectorAll('.glyph-measurer').forEach((el) => {
      document.body.removeChild(el);
    });
    GlyphMeasurer._instance = undefined;
  }

  public static initiate() {
    GlyphMeasurer._instance = new GlyphMeasurer();
  }

  public measureChar(char: string, options: Options): MeasurementResult {
    const l = Math.ceil(options.size * 1.5);
    const fontStr = [options.size].join(' ') + 'px ' + options.family;

    this._canvas.height = l * 10;
    this._canvas.width = l * 10;
    this._context.font = fontStr;

    const result: MeasurementResult = {
      capHeight: 0,
      height: 0,
      depth: 0,
    };

    const cached = this._cache[options.family + char];
    if (cached) {
      return cached;
    }

    // measure line-height
    this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    this._context.textBaseline = 'top';
    this._context.fillStyle = '#000000';
    this._context.fillText(char, 0, 0);
    const topPx = GlyphMeasurer.firstTop(this._context.getImageData(0, 0, l, l));
    const bottomPx = GlyphMeasurer.firstBottom(this._context.getImageData(0, 0, l, l));

    result.height = (bottomPx - topPx);

    // measure baseline
    this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    this._context.textBaseline = 'alphabetic';
    this._context.fillText(char, 0, l);
    const baselinePx = GlyphMeasurer.firstTop(this._context.getImageData(0, 0, l, l));
    const baseline = l - baselinePx - 1 + topPx;

    this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);
    this._context.textBaseline = 'top';
    this._context.fillText(char, 0, 0);
    const upper = GlyphMeasurer.firstTop(this._context.getImageData(0, 0, l, l));
    result.capHeight = (baseline - upper);

    this._context.clearRect(0, 0, this._canvas.width, this._canvas.height);

    this._cache[options.family + char] = result;

    result.depth = bottomPx - baselinePx;

    GYPH_MESURING_DUMP.push({
      fontStr,
      charCode: Number(char.charCodeAt(0)),
      char,
      options,
      result,
    });

    return result;
  }

  static firstTop(iData: ImageData): number {
    const l = iData.height;
    const data = iData.data;
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] !== 0) {
        return Math.floor((i - 3) * 0.25 / l);
      }
    }
    return -1;
  }

  static firstBottom(iData: ImageData): number {
    const l = iData.height;
    const data = iData.data;
    for (let i = data.length - 1; i > 0; i -= 4) {
      if (data[i] !== 0) {
        return Math.floor((i - 3) * 0.25 / l);
      }
    }
    return -1;
  }
}
